import 'bootstrap/dist/css/bootstrap.css';
import './App.css';


import { useState } from 'react';

import Header from './Header';
import Body from './Body'
import Footer from './Footer'
import ScrollToTop from './components/ScrollToTop';
import FavoriteDealNotifier from './components/FavoriteDealNotifier';

import {StoreContext} from './contexts/StoreContext';
import Stores from './config/stores';
import { BrowserRouter } from 'react-router-dom';
import { applyPreferredStores, loadProfile } from './utils/profileStorage';


function App() {
  
  const [stores, setStores] = useState(() => {
    const profile = loadProfile();
    return applyPreferredStores(Stores, profile.preferredStoreKeys);
  });

  return (
    <>
        <BrowserRouter>
      <ScrollToTop />
      <FavoriteDealNotifier />
      <StoreContext.Provider value={{stores, setStores}}>

        <Header>
        </Header>
        
        <Body>

        </Body>


        <Footer>

        </Footer>

        </StoreContext.Provider>
        </BrowserRouter>
    </>

  );
}

export default App;
